export enum AccountStateEnum {
    profile = "profile",
    company = "company",
    orderHistory = "order-history",
    settings = "settings",
}
